import React from 'react';

const LogoMono: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 272.4 278.13"
    {...props}
  >
    <path
      fill="#ffffff"
      d="M34.15 129.23A34.15 34.15 0 000 163.38v62.12h10.83A34.15 34.15 0 0045 191.35v-62.12z"
    ></path>
    <path
      fill="#ffffff"
      d="M91 83.57a34.15 34.15 0 00-34.16 34.15v129h10.84a34.15 34.15 0 0034.16-34.15v-129z"
    ></path>
    <path
      fill="#ffffff"
      d="M147.86 35.63a34.15 34.15 0 00-34.15 34.15v143.5h10.83a34.15 34.15 0 0034.15-34.15V35.63z"
    ></path>
    <path
      fill="#ffffff"
      d="M204.71 49.73a34.15 34.15 0 00-34.15 34.15v169.4h10.83a34.15 34.15 0 0034.15-34.15V49.73z"
    ></path>
    <path
      fill="#ffffff"
      d="M261.57 0a34.15 34.15 0 00-34.15 34.15v244h10.83A34.15 34.15 0 00272.4 244V0z"
    ></path>
  </svg>
);

export default LogoMono;
